import { ComponentClass, ComponentType } from 'react';
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom';
import { AuthConsumer } from '../../providers/AuthProvider';
import { isAuthenticated } from '../../services/AuthService';
import AuthRender from './AuthRender';
import LoaderGlobal from 'components/Loader/LoaderApp/LoaderGlobal';

interface PrivateRouteProps extends RouteProps {
  component?: ComponentType<RouteComponentProps<any>> | ComponentClass<RouteComponentProps<any>>;
}

interface AuthConsumerProps {
  signinRedirect: () => void;
}

export function PrivateRoute({ component, ...rest }: PrivateRouteProps) {

  const renderFn =
    (Component?: ComponentType<RouteComponentProps<any>> | ComponentClass<RouteComponentProps<any>>) => (props: RouteComponentProps<any>) =>
    (
      <AuthConsumer>
        {({ signinRedirect }: AuthConsumerProps) => {
          const routeProps = {
            ...props,
          };
          if (!!Component && isAuthenticated()) {
            return (
              <AuthRender>
                <Component {...routeProps} />
              </AuthRender>
            );
          } else {
            signinRedirect();
            return (
              <div className='container'>
                <LoaderGlobal />
              </div>
            );
          }
        }}
      </AuthConsumer>
    );

  return (
    <Route
      {...rest}
      render={
        typeof rest.render === 'function' ? rest.render : renderFn(component)
      }
    />
  );
}